module.exports = __webpack_public_path__ + "img/energy-shield-mk2-equipment.b0717860.png";